import { useState } from 'react';
import Modal from '../ui/Modal';
import Textarea from '../ui/Textarea';
import Button from '../ui/Button';

export default function WithdrawDialog({ open, onClose, onConfirm, loading }) {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(reason);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Backout candidate"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm} loading={loading} disabled={!reason.trim()}>
            Backout
          </Button>
        </>
      }
    >
      <Textarea
        label="Reason"
        placeholder="Why is this candidate backing out?"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        required
      />
    </Modal>
  );
}
